import(/* webpackMode: "eager", webpackExports: ["FaqContent"] */ "/opt/build/repo/src/app/(site)/faq/components/content.tsx");
